export const DAYS = [
  { key: "lun", label: "L" },
  { key: "mar", label: "M" },
  { key: "mie", label: "M" },
  { key: "jue", label: "J" },
  { key: "vie", label: "V" },
  { key: "sab", label: "S" },
];

const mxn = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" });
export const money = (n) => mxn.format(Number(n) || 0);

export function computeRow(entry) {
  const weekly = Number(entry.weekly_salary) || 0;
  const daily = weekly / 6;
  let asistencias = 0;
  let faltas = 0;
  let dias = 0; // días efectivamente trabajados (1 + medios). Vacío = no cuenta.
  DAYS.forEach(({ key }) => {
    const v = entry.attendance?.[key];
    if (v === 1) { dias += 1; asistencias += 1; }
    else if (v === 0.5) { dias += 0.5; asistencias += 0.5; faltas += 0.5; }
    else if (v === 0) { faltas += 1; }
    // null / vacío: no suma nada
  });
  const descuentoFaltas = faltas * daily;
  const totalPrestamos = DAYS.reduce((s, { key }) => s + (Number(entry.loans?.[key]) || 0), 0);
  const abonoPrestamo = Number(entry.abono_prestamo) || 0;
  const sueldoCalculado = dias * daily; // solo días trabajados, los vacíos no se pagan aún
  const totalPagar = sueldoCalculado - totalPrestamos - abonoPrestamo;
  return { weekly, daily, asistencias, faltas, descuentoFaltas, totalPrestamos, abonoPrestamo, sueldoCalculado, totalPagar };
}

export function aggregate(entries) {
  return entries.reduce(
    (acc, e) => {
      const c = computeRow(e);
      acc.nominaBase += c.weekly;
      acc.totalPagar += c.totalPagar;
      acc.totalPrestamos += c.totalPrestamos;
      acc.abonoPrestamo += c.abonoPrestamo;
      acc.descuentoFaltas += c.descuentoFaltas;
      acc.faltas += c.faltas;
      acc.asistencias += c.asistencias;
      return acc;
    },
    { nominaBase: 0, totalPagar: 0, totalPrestamos: 0, abonoPrestamo: 0, descuentoFaltas: 0, faltas: 0, asistencias: 0 }
  );
}

export function fmtRange(start, end) {
  if (!start || !end) return "Sin fechas";
  const opt = { day: "numeric", month: "short" };
  const s = new Date(start + "T00:00:00").toLocaleDateString("es-MX", opt);
  const e = new Date(end + "T00:00:00").toLocaleDateString("es-MX", { ...opt, year: "numeric" });
  return `${s} – ${e}`;
}
